





















































import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';

import { GET_APIKEY, GET_AUTHENTICATED } from '@/store/modules/auth/types';
import {
  GET_VIDEO_STORE,
  REMOVE_VIDEO_STORE,
} from '../store/modules/video/types';

import AuthMixin from '@/mixins/AuthMixin';

@Component
export default class Navbar extends Mixins(AuthMixin) {
  get authenticated() {
    return this.$store.getters[`auth/${GET_AUTHENTICATED}`];
  }

  get videoStore() {
    return this.$store.getters[`video/${GET_VIDEO_STORE}`];
  }

  newVideo() {
    this.$store.dispatch(`video/${REMOVE_VIDEO_STORE}`);
    if (this.$router.currentRoute.name !== 'home') {
      this.$router.push('/');
    }
  }

  async logout() {
    if (this.$store.getters[`auth/${GET_APIKEY}`]) {
      this.$buefy.dialog.confirm({
        title: 'Log out',
        message:
          'Are you sure you want log out? Make sure to keep a note of your key.',
        confirmText: 'Log out',
        type: 'is-warning',
        hasIcon: true,
        onConfirm: async () => {
          await this.authInvalidate();
          this.$buefy.toast.open('Successfully logged out.');
          this.newVideo();
        },
      });
    } else {
      await this.authInvalidate();
      this.$buefy.toast.open('Successfully logged out.');
      this.newVideo();
    }
  }
}
